import { Text } from '@thanx/uikit/text'
import { useStyletron } from '@thanx/uikit/theme'
import React from 'react'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

type Props = {
  variables: Record<string, string>
}

const AvailableVariables: React.FC<Props> = ({ variables }) => {
  const [css] = useStyletron()

  if (Object.keys(variables).length === 0) return null

  return (
    <>
      <Text.BodyText5
        color="grey50"
        className={css({ marginBottom: '4px', display: 'block' })}
      >
        Available variables:
      </Text.BodyText5>
      <div
        className={css({
          display: 'flex',
          flexWrap: 'wrap',
          gap: '8px',
        })}
      >
        {Object.entries(variables).map(([key, description]) => (
          <OverlayTrigger
            key={key}
            placement="top"
            overlay={<Tooltip id={`tooltip-var-${key}`}>{description}</Tooltip>}
          >
            <span
              className={css({
                backgroundColor: '#E3F2FD',
                color: '#1976D2',
                padding: '2px 8px',
                borderRadius: '4px',
                fontSize: '12px',
                cursor: 'help',
              })}
            >
              {`{${key}}`}
            </span>
          </OverlayTrigger>
        ))}
      </div>
    </>
  )
}

export default AvailableVariables
